module.exports = __webpack_public_path__ + "img/question_top_bg_1.063129a9.png";